module.exports = __webpack_public_path__ + "static/media/5.bad7fac3.jpg";